import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMouseClassic2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconMouseClassic2"><Path d="M19 15C19 18.8659 15.866 22 12 22C8.13404 22 5.00005 18.8659 5 15V10.5H19V15Z" fill="currentColor"/><Path d="M11.25 9H5V4.75C5.00001 3.23123 6.23123 2 7.75 2H11.25V9Z" fill="currentColor"/><Path d="M16.25 2C17.7687 2.00002 18.9999 3.2313 19 4.75V9H12.75V2H16.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMouseClassic2;
